import { c as _c } from "react/compiler-runtime";
import { Table, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import Subsection from '../../../../../subsection';
import type { BusinessInsightDisplayOptions } from '../../../../onboarding-business-insight';
import type { FormattedPerson } from '../../../../onboarding-business-insight.types';
import MobileRow from './components/mobile-row';
import Row from './components/row';
type PeopleProps = {
  data: FormattedPerson[];
  displayOptions?: BusinessInsightDisplayOptions;
};
const People = t0 => {
  const $ = _c(16);
  const {
    data,
    displayOptions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.people"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isMobile = useMobileLayout();
  let t2;
  if ($[1] !== isMobile || $[2] !== t) {
    t2 = isMobile ? [{
      text: t(_temp)
    }] : [{
      text: t(_temp2),
      width: "60%"
    }, {
      text: t(_temp3),
      width: "40%"
    }];
    $[1] = isMobile;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const columns = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp4);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp5);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isMobile ? renderMobileTr : renderTr;
  const t6 = displayOptions?.tableVariant;
  let t7;
  if ($[8] !== columns || $[9] !== data || $[10] !== isMobile || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Subsection><Table aria-label={t3} columns={columns} emptyStateText={t4} getKeyForRow={_temp6} hideThead={isMobile} items={data} renderTr={t5} variant={t6} /></Subsection>;
    $[8] = columns;
    $[9] = data;
    $[10] = isMobile;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
const renderTr = ({
  item
}: TableRow<FormattedPerson>) => <Row person={item} />;
const renderMobileTr = ({
  item
}: TableRow<FormattedPerson>) => <MobileRow person={item} />;
export default People;
function _temp($) {
  return $.table.header.name;
}
function _temp2($_0) {
  return $_0.table.header.name;
}
function _temp3($_1) {
  return $_1.table.header.role;
}
function _temp4($_2) {
  return $_2.table.ariaLabel;
}
function _temp5($_3) {
  return $_3.table.emptyState;
}
function _temp6(person) {
  return `${person.name} ${person.role}`;
}